interface StringCell{
	value:string,
	className?:string
}
export const StringCell = ({value, className=""}:StringCell) => {
	return (
		<div className={className}>
			{value}
		</div>
	)
}